import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import classes from './checkoutTable.module.scss';
import Checkbox from '../../../../../_common/Form/Checkbox/Checkbox';
import utils from '../../../../../../utils/utils';
import InputField from '../../../../../_common/Form/TextFields/InputField';

const header = [
  {
    name: 'Status',
    path: 'status',
  },
  {
    name: 'Rx Number',
    path: 'rxNumber',
  },
  {
    name: 'Process ON',
    path: 'processedOn',
  },
  {
    name: 'Medication',
    path: 'Product.name',
  },
  {
    name: 'Amount',
    path: 'amount',
  },
  {
    name: 'Paid',
    path: 'paid',
  },
  {
    name: 'Balance',
    path: 'balance',
  },
];

const CheckoutTable = ({
  checkoutData, activeAmountId, setActiveAmountId, changeAmount, checkedIds, setCheckedIds, totalAmount,
}) => {
  const isCheckedAllAmount = !!checkoutData.every((d) => checkedIds.includes(d.id));

  const setActiveId = (id) => {
    const amount = checkoutData.find((d) => d.id === activeAmountId)?.amount;

    if (!amount) {
      changeAmount(activeAmountId, 0);
    }

    setActiveAmountId(id);
  };

  const closeElement = (e) => {
    if (!e.target.closest('[id="amount"]') && activeAmountId) {
      setActiveId('');
    }
  };

  useEffect(() => {
    window.addEventListener('click', closeElement);

    return () => {
      window.removeEventListener('click', closeElement);
    };
  }, [activeAmountId, checkoutData]);

  const checkAmount = (id) => {
    if (id === 'all') {
      setCheckedIds(() => {
        if (isCheckedAllAmount) {
          return [];
        }

        return checkoutData.map((d) => d.id);
      });
    } else {
      setCheckedIds((prev) => {
        if (prev.includes(id)) {
          return prev.filter((p) => p !== id);
        }

        return [...prev, id];
      });
    }
  };

  return (
    <div className={classes.table_wrapper}>
      <div className={classes.total}>
        Total:
        <span>
          $
          {totalAmount}
        </span>
      </div>

      <div className={classes.table}>
        <table>
          <thead>
            <tr>
              <th>
                <Checkbox
                  onChange={() => checkAmount('all')}
                  checked={isCheckedAllAmount}
                />
              </th>

              {header.map((h) => (
                <th key={h.name}>{h.name}</th>
              ))}
            </tr>
          </thead>

          <tbody id="tbody">
            {checkoutData.map((d) => (
              <tr key={d.id}>

                <td>
                  <Checkbox
                    onChange={() => checkAmount(d.id)}
                    checked={checkedIds.includes(d.id)}
                  />
                </td>

                {header.map((h) => (
                  h.path === 'processedOn'
                    ? (
                      <td key={h.name}>
                        {moment(d[h.path]).isValid()
                          ? moment(d[h.path]).format('MM/DD/YYYY')
                          : '-'}
                      </td>
                    )
                    : h.path === 'amount'
                      ? (
                        <td
                          key={h.name}
                          onClick={() => setActiveId(d.id)}
                          id="amount"
                        >
                          {activeAmountId === d.id
                            ? (
                              <InputField
                                wrapperClassName={classes.amount_field_wrapper}
                                autoFocus
                                onChange={(value) => changeAmount(d.id, value)}
                                value={d[h.path] || ''}
                                onKeyPress={(e) => utils.keyPressCurrency(e, false)}
                                onPaste={(e) => utils.keyPressCurrency(e, true)}
                              />
                            )
                            : _.get(d, h.path) ?? '-'}
                        </td>
                      )
                      : <td key={h.name}>{_.get(d, h.path) ?? '-'}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

CheckoutTable.propTypes = {
  checkoutData: PropTypes.array.isRequired,
  activeAmountId: PropTypes.string.isRequired,
  setActiveAmountId: PropTypes.func.isRequired,
  changeAmount: PropTypes.func.isRequired,
  totalAmount: PropTypes.number.isRequired,
  checkedIds: PropTypes.array.isRequired,
  setCheckedIds: PropTypes.func.isRequired,
};

export default CheckoutTable;
